import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translateEn, translateTr, translateAr, translateEs } from 'src/locals/translations';
import { createStore } from 'redux';
import { rootReducer } from './app/redux/reducers/root.reducer';

const store = createStore(rootReducer);

const state = store.getState();
const { preferredLanguage } = state.userState;

export const resources = {
  en: { translation: translateEn },
  tr: { translation: translateTr },
  ar: { translation: translateAr },
  es: { translation: translateEs },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: preferredLanguage || 'en',
  fallbackLng: 'en',
  debug: false,
  defaultNS: 'translation',
  keySeparator: '.',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
